import * as types from '@/components/Database/database.types';
import i18n from '@/plugins/i18n';
const databaseCBGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      title: i18n.global.t('dbm.cluster-cpu-usage'),
      header: {
        title: i18n.global.t('dbm.cluster-cpu-usage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_clusters_cluster_cpu_percent',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.cpu-usage'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.cpu-usage'),
      },
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.cluster-ram-usage'),
      header: {
        title: i18n.global.t('dbm.cluster-ram-usage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_clusters_cluster_mem_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('ramUsage'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('ramUsage'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
    },
  ],
  cardComponents: {
    width: '21.3%',
    cardName: [
      types.couchbaseCardNames.CLUSTER_NAME,
      types.couchbaseCardNames.COUCHBASE_VERSION,
      types.couchbaseCardNames.STATUS,
      types.couchbaseCardNames.NO_OF_NODES,
      types.couchbaseCardNames.NO_OF_BUCKETS,
    ],
  },
});
export default databaseCBGraphs;
